import { Application } from 'stimulus';
import './sign-up.scss';

import { registerPasswordInput, registerTextInput, registerForm } from './../../controls';
import { registerSignUpFormController } from './sign-up-form.controller';

const app = Application.start();
registerTextInput(app);
registerPasswordInput(app);
registerSignUpFormController(app);
registerForm(app);
